import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SidePanelStreamsService } from 'src/app/feature/map-viewer/side-panel/side-panel-streams.service';
import { ButtonType } from 'src/app/shared/common/components/buttons/button';

import { Subject, takeUntil } from 'rxjs';
import { MessagingService } from 'src/app/core/messaging/messaging.service';
import { TranslationService } from 'src/app/core/translation/translation.service';
import { FeaturesStreamsService } from 'src/app/shared/common/current-features/features-streams.service';
import { ProjectStreamService } from 'src/app/shared/common/current-project/project-stream.service';
import { WorkspaceType } from 'src/app/shared/map-data-services/mapWorkspace/map-workspace.types';
import { ProjectTaskMigrationStatus } from 'src/app/shared/map-data-services/project/project';
import { SidePanelName } from '../../../side-panel/side-panel.component';
import { collaborationToolList, CollaborationToolListItem } from './collaboration-tool-list';

@Component({
    selector: 'collaboration-tools',
    templateUrl: './collaboration-tools.component.html'
})
export class CollaborationToolsComponent implements OnInit, OnDestroy {
    @Input()
    public map: L.Map;

    private isTaskMigrationInProgress: boolean = false;

    // expose ButtonType enum to template
    public ButtonType = ButtonType;
    public WorkspaceType = WorkspaceType;
    public collaborationToolList: CollaborationToolListItem[];

    private destroyed$ = new Subject<void>();

    constructor(
        private projectStreamService: ProjectStreamService,
        private sidePanelStreams: SidePanelStreamsService,
        private featuresStreams: FeaturesStreamsService,
        private messaging: MessagingService,
        private translate: TranslationService,
        private router: Router
    ) {
        this.collaborationToolList = collaborationToolList;
    }

    ngOnInit(): void {
        this.projectStreamService.taskMigrationStatusStream.pipe(takeUntil(this.destroyed$)).subscribe(status => {
            if (
                status === ProjectTaskMigrationStatus.IN_PROGRESS ||
                status === ProjectTaskMigrationStatus.PENDING ||
                status === ProjectTaskMigrationStatus.COMPLETED
            ) {
                this.collaborationToolList = this.collaborationToolList.filter(item => item.name !== 'todo');
            }
        });
    }

    public selectTool(selectedTool: CollaborationToolListItem): boolean {
        if (this.featuresStreams.isLoadingFeatures$.getValue()) {
            this.messaging.showWarning(this.translate.instant('TC.MapViewer.ActionNotAllowed'));
            return false;
        }

        this.collaborationToolList.forEach(tool => {
            tool.selected = selectedTool.id === tool.id;
        });
        switch (selectedTool.name) {
            case 'todo':
                this.sidePanelStreams.closeSidePanel(SidePanelName.EXISTING_TEMPLATE);
                this.sidePanelStreams.closeSidePanel(SidePanelName.EXISTING_LAYER);
                this.sidePanelStreams.closeAndReopenSidePanel(SidePanelName.LEGACY_TASK_DETAIL, { taskId: null });
                break;
            case 'export':
                this.router.navigate(['mapViewer', { outlets: { centerDialog: 'export' } }], {
                    queryParamsHandling: 'preserve'
                });
                break;
        }
        return true;
    }

    ngOnDestroy(): void {
        this.destroyed$.next(null);
    }
}
